import { Box, Chip } from "@mui/material";
import { useState } from "react";
import apiHost, { appHost, host } from "../../../api/apihost";
import { useQueryAutomobile } from "../../../api/queries";
import Button from "../../../components/button/customButton";
import Datagrid from "../../../components/layout/customTable/Datagrid";
import SectionLayout from "../../../components/layout/sectionLayout";
import FormCreateEditCar from "../../../shared/formCreateEditCar";
import { formatDate } from "../../../utils/formatDate";
import { newSelectObjectByProperties } from "../../../utils/selectObjectByProperties";

const AutomobileList = () => {
  const { data } = useQueryAutomobile();
  const [showCreate, setShowCreate] = useState(false);
  const columns = [
    { label: "id", property: "id" },
    {
      label: "Image",
      property: "image",
      formatter: (text: string) => (
        <Box
          component="img"
          sx={{
            height: 100,
            width: 100,
            maxHeight: { xs: 100, md: 100 },
            maxWidth: { xs: 100, md: 100 },
          }}
          alt=""
          src={
            text.startsWith("uploads") ? `${appHost}${text}` : `${host}${text}`
          }
        />
      ),
    },
    {
      label: "Nom",
      property: "nom",
      formatter: (text: string) => (
        <span dangerouslySetInnerHTML={{ __html: text }} />
      ),
    },

    {
      label: "Date d'enregistrement",
      property: "registered",
      formatter: formatDate,
    }, // Assurez-vous que la propriété "action" existe dans vos objets row
  ];
  const list = data?.data || [];
  const selectedRows = newSelectObjectByProperties(list, columns);

  return (
    <div>
      <SectionLayout
        title="Tous les projets"
        rightContent={
          <Button onClick={() => setShowCreate(true)}>Ajouter un projet</Button>
        }
      >
        <FormCreateEditCar
          car={undefined}
          show={showCreate}
          setShow={setShowCreate}
          context="create"
        />
        <Datagrid columns={columns} rows={selectedRows} showButton editButton />
      </SectionLayout>
    </div>
  );
};

export default AutomobileList;
